import * as React from 'react';
import { Modal, WhiteButton } from 'components';
import moment = require('moment');
import DateFilter from './DateFilter';
import HoursFilter from './HoursFilter';
import { IModalAction } from 'models/modal';

const formKeys = {
	timeFrom: 'filter.timeFrom',
	timeTo: 'filter.timeTo',
	date: 'filter.date',
	selectedAppointment: 'selectedAppointment',
} as const;

interface IProps {
	showHeaderCloseButton: boolean;
	closeModal: () => IModalAction;
	t?: (key: string) => string;
	change: (type: string, modalProps: any) => IModalAction;
	filters: {
		date?: string;
		timeFrom?: number;
		timeTo?: number;
	};
}

const SetFiltersAppointmentModal = (props: IProps) => {
	const { showHeaderCloseButton, closeModal, t, change, filters } = props;
	const [resetAppliedDateFilters, setResetAppliedDateFilters] = React.useState(false);
	const [resetAppliedTimeFilters, setResetAppliedTimeFilters] = React.useState(false);

	const sectionTitle = (text: string, resetAction?: (x: any, e?: React.MouseEvent) => void): JSX.Element => {
		return (
			<>
				<div className="sectionDivider" />
				<div className="sectionTitleContainer">
					<p className="p14">{text.toUpperCase()}</p>
					{resetAction ? (
						<div onClick={() => resetAction(this)} className="pointer">
							{t('BSPortal_Common_Reset')}
						</div>
					) : null}
				</div>
			</>
		);
	};

	const resetDate = () => {
		change(formKeys.date, '');
		setResetAppliedDateFilters(true);
	};
	const resetTime = () => {
		change(formKeys.timeFrom, null);
		change(formKeys.timeTo, null);
		setResetAppliedTimeFilters(true);
	};

	return (
		<Modal
			title={t('Search_Salons_Filter_Title')}
			showHeaderCloseButton={showHeaderCloseButton}
			closeModal={closeModal}
			modalClass={`setFiltersModal `}
			scrollModalToTopOnOpen={true}
			stickyHeader={true}
		>
			<div className="row">
				<div className="col-md-12">
					{sectionTitle(t('BSPortal_Common_Date'), resetDate)}
					<DateFilter
						filterDate={filters?.date}
						resetAppliedFilters={resetAppliedDateFilters}
						setResetAppliedFilters={setResetAppliedDateFilters}
						displayOnlyDatepicker={true}
						onChange={(d: Date) => {
							change(formKeys.date, moment(d).toISOString());
						}}
					/>
					{sectionTitle(t('BookAppointment_Schedule_Filter_Time'), resetTime)}
					<HoursFilter
						filterFrom={filters?.timeFrom}
						filterTo={filters?.timeTo}
						resetAppliedFilters={resetAppliedTimeFilters}
						setResetAppliedFilters={setResetAppliedTimeFilters}
						displayOnlyRangeSlider={true}
						onChange={({ min, max }) => {
							change(formKeys.timeFrom, min);
							change(formKeys.timeTo, max);
						}}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12">
					<div className="buttonContainer d-flex flex-column">
						<WhiteButton onClick={closeModal}>{t('BSPortal_Common_Confirm')}</WhiteButton>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export { SetFiltersAppointmentModal };
